module.exports = __webpack_public_path__ + "less.svg?e2981eaf83136471b5424c143a7340f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/less.svg
// module id = 291
// module chunks = 2